"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

/**
 * A higher-order component to assist with the React 16 migration.
 *
 * In react@15 `connect`ing a functional component was unsupported but failed
 * silently. In react@16, however, this throws an error. This utility serves
 * to temporarily wrap those functional components with classes until either a
 * context-based or hook-based API is available for `general-store`.
 *
 * @param {Function} WrappedComponent - Functional component to wrap
 * @returns {React.Component} Class container for WrappedComponent
 */
function WithClassWrapper(WrappedComponent) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_React$Component) {
    (0, _inherits2.default)(ClassWrapper, _React$Component);

    function ClassWrapper() {
      (0, _classCallCheck2.default)(this, ClassWrapper);
      return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ClassWrapper).apply(this, arguments));
    }

    (0, _createClass2.default)(ClassWrapper, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            children = _this$props.children,
            passthruProps = (0, _objectWithoutProperties2.default)(_this$props, ["children"]);
        return _react.default.createElement(WrappedComponent, passthruProps, children);
      }
    }]);
    return ClassWrapper;
  }(_react.default.Component), _class.WrappedComponent = WrappedComponent, _temp;
}

var _default = WithClassWrapper;
exports.default = _default;
module.exports = exports.default;